import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { formatDate } from '@utils/date.utils'

import { TaxHistoryDto } from '@model/TaxHistoryDto'

import { StatusBadge, TestBadgeMap } from '@shared/components/StatusBadge/StatusBadge'

interface Props {
  history: TaxHistoryDto[]
}

export const TestStatusHistoryModal: BaseModalType<Props> = (props) => {
  const { history, close } = props
  const { t } = useTranslation()
  const [auth] = useContext(AuthSessionContext)
  const dateFormat = auth?.dateFormatType?.name

  const parsedData = history?.map((item) => ({
    badge: <StatusBadge badgeMap={TestBadgeMap} {...item.testStatus} />,
    title: `${t('Date')}: ${formatDate(item.dateTaken, { formatType: dateFormat })}`,
  }))

  return (
    <Modal>
      <Modal.Header>{t('Status History')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Status statuses={parsedData} />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
